/* eslint-disable */

import { isCameraStreamLogsEnabled } from 'services/CameraStream/config';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true,
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError(
        'Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
    );
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === 'string') return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor) n = o.constructor.name;
    if (n === 'Map' || n === 'Set') return Array.from(n);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f,
        y,
        t,
        g,
        _ = {
            label: 0,
            sent: function () {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: [],
        };
    return (
        (g = {
            next: verb(0),
            throw: verb(1),
            return: verb(2),
        }),
        typeof Symbol === 'function' &&
            (g[Symbol.iterator] = function () {
                return this;
            }),
        g
    );
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError('Generator is already executing.');
        while (_)
            try {
                if (
                    ((f = 1),
                    y &&
                        (t = op[0] & 2 ? y['return'] : op[0] ? y['throw'] || ((t = y['return']) && t.call(y), 0) : y.next) &&
                        !(t = t.call(y, op[1])).done)
                )
                    return t;
                if (((y = 0), t)) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false,
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!((t = _.trys), (t = t.length > 0 && t[t.length - 1])) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];
                y = 0;
            } finally {
                f = t = 0;
            }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true,
        };
    }
}
var DEFAULT_CONNECT_TIMEOUT = 2000;
export var WHEPType;
(function (WHEPType) {
    WHEPType[(WHEPType['Client'] = 0)] = 'Client';
    WHEPType[(WHEPType['Server'] = 1)] = 'Server';
})(WHEPType || (WHEPType = {}));
export var AIQAdapter = /*#__PURE__*/ (function () {
    'use strict';
    function AIQAdapter(peer, channelUrl, onError, mediaConstraints) {
        _class_call_check(this, AIQAdapter);
        var _this_mediaConstraints, _this_mediaConstraints1;
        _define_property(this, 'localPeer', void 0);
        _define_property(this, 'channelUrl', void 0);
        _define_property(this, 'credeintials', void 0);
        _define_property(this, 'debug', false);
        _define_property(this, 'whepType', void 0);
        _define_property(this, 'waitingForCandidates', false);
        _define_property(this, 'iceGatheringTimeout', void 0);
        _define_property(this, 'resource', null);
        _define_property(this, 'onErrorHandler', void 0);
        _define_property(this, 'audio', void 0);
        _define_property(this, 'video', void 0);
        _define_property(this, 'mediaConstraints', void 0);
        this.mediaConstraints = mediaConstraints;
        this.credeintials = channelUrl.username + ':' + channelUrl.password;
        channelUrl.password = channelUrl.username = '';
        this.channelUrl = channelUrl;
        this.log('URL', this.channelUrl);
        this.log('CREDENTIALS', this.credeintials);
        if (typeof this.channelUrl === 'string') {
            throw new Error('channelUrl parameter expected to be an URL not a string');
        }
        this.whepType = 0;
        this.onErrorHandler = onError;
        this.audio = !((_this_mediaConstraints = this.mediaConstraints) === null || _this_mediaConstraints === void 0
            ? void 0
            : _this_mediaConstraints.videoOnly);
        this.video = !((_this_mediaConstraints1 = this.mediaConstraints) === null || _this_mediaConstraints1 === void 0
            ? void 0
            : _this_mediaConstraints1.audioOnly);
        this.resetPeer(peer);
    }
    _create_class(AIQAdapter, [
        {
            key: 'enableDebug',
            value: function enableDebug() {
                this.debug = true;
            },
        },
        {
            key: 'resetPeer',
            value: function resetPeer(newPeer) {
                this.localPeer = newPeer;
                this.localPeer.onicegatheringstatechange = this.onIceGatheringStateChange.bind(this);
                this.localPeer.onicecandidate = this.onIceCandidate.bind(this);
            },
        },
        {
            key: 'getPeer',
            value: function getPeer() {
                return this.localPeer;
            },
        },
        {
            key: 'connect',
            value: function connect(opts) {
                var _this = this;
                return _async_to_generator(function () {
                    var error;
                    return _ts_generator(this, function (_state) {
                        switch (_state.label) {
                            case 0:
                                _state.trys.push([0, 2, , 3]);
                                return [4, _this.initSdpExchange()];
                            case 1:
                                _state.sent();
                                return [3, 3];
                            case 2:
                                error = _state.sent();
                                _this.error(error.toString());
                                return [3, 3];
                            case 3:
                                return [2];
                        }
                    });
                })();
            },
        },
        {
            key: 'disconnect',
            value: function disconnect() {
                var _this = this;
                return _async_to_generator(function () {
                    var response;
                    return _ts_generator(this, function (_state) {
                        switch (_state.label) {
                            case 0:
                                if (!_this.resource) return [3, 2];
                                _this.log('Disconnecting by removing resource '.concat(_this.resource));
                                return [
                                    4,
                                    fetch(_this.resource, {
                                        method: 'DELETE',
                                        headers: {
                                            Authorization: 'Basic ' + btoa(_this.credeintials),
                                        },
                                    }),
                                ];
                            case 1:
                                response = _state.sent();
                                if (response.ok) {
                                    _this.log('Successfully removed resource');
                                }
                                _state.label = 2;
                            case 2:
                                return [2];
                        }
                    });
                })();
            },
        },
        {
            key: 'initSdpExchange',
            value: function initSdpExchange() {
                var _this = this;
                return _async_to_generator(function () {
                    var offer, opusCodecId, offer1, answer, error;
                    return _ts_generator(this, function (_state) {
                        switch (_state.label) {
                            case 0:
                                clearTimeout(_this.iceGatheringTimeout);
                                if (!(_this.localPeer && _this.whepType === 0)) return [3, 3];
                                if (_this.video)
                                    _this.localPeer.addTransceiver('video', {
                                        direction: 'recvonly',
                                    });
                                if (_this.audio)
                                    _this.localPeer.addTransceiver('audio', {
                                        direction: 'recvonly',
                                    });
                                return [4, _this.localPeer.createOffer()];
                            case 1:
                                offer = _state.sent();
                                // To add NACK in offer we have to add it manually see https://bugs.chromium.org/p/webrtc/issues/detail?id=4543 for details
                                if (offer.sdp) {
                                    opusCodecId = offer.sdp.match(/a=rtpmap:(\d+) opus\/48000\/2/);
                                    if (opusCodecId !== null) {
                                        offer.sdp = offer.sdp.replace(
                                            'opus/48000/2\r\n',
                                            'opus/48000/2\r\na=rtcp-fb:' + opusCodecId[1] + ' nack\r\n'
                                        );
                                    }
                                }
                                return [4, _this.localPeer.setLocalDescription(offer)];
                            case 2:
                                _state.sent();
                                _this.waitingForCandidates = true;
                                _this.iceGatheringTimeout = setTimeout(_this.onIceGatheringTimeout.bind(_this), DEFAULT_CONNECT_TIMEOUT);
                                return [3, 10];
                            case 3:
                                if (!_this.localPeer) return [3, 10];
                                return [4, _this.requestOffer()];
                            case 4:
                                offer1 = _state.sent();
                                return [
                                    4,
                                    _this.localPeer.setRemoteDescription({
                                        type: 'offer',
                                        sdp: offer1,
                                    }),
                                ];
                            case 5:
                                _state.sent();
                                return [4, _this.localPeer.createAnswer()];
                            case 6:
                                answer = _state.sent();
                                _state.label = 7;
                            case 7:
                                _state.trys.push([7, 9, , 10]);
                                return [4, _this.localPeer.setLocalDescription(answer)];
                            case 8:
                                _state.sent();
                                _this.waitingForCandidates = true;
                                _this.iceGatheringTimeout = setTimeout(_this.onIceGatheringTimeout.bind(_this), DEFAULT_CONNECT_TIMEOUT);
                                return [3, 10];
                            case 9:
                                error = _state.sent();
                                _this.log(answer.sdp);
                                throw error;
                            case 10:
                                return [2];
                        }
                    });
                })();
            },
        },
        {
            key: 'onIceCandidate',
            value: function onIceCandidate(event) {
                var _this = this;
                return _async_to_generator(function () {
                    var candidateEvent, candidate;
                    return _ts_generator(this, function (_state) {
                        if (event.type !== 'icecandidate') {
                            return [2];
                        }
                        candidateEvent = event;
                        candidate = candidateEvent.candidate;
                        if (!candidate) {
                            return [2];
                        }
                        _this.log(candidate.candidate);
                        return [2];
                    });
                })();
            },
        },
        {
            key: 'onIceGatheringStateChange',
            value: function onIceGatheringStateChange(event) {
                if (this.localPeer) {
                    this.log('IceGatheringState', this.localPeer.iceGatheringState);
                    if (this.localPeer.iceGatheringState !== 'complete' || !this.waitingForCandidates) {
                        return;
                    }
                    this.onDoneWaitingForCandidates();
                }
            },
        },
        {
            key: 'onIceGatheringTimeout',
            value: function onIceGatheringTimeout() {
                this.log('IceGatheringTimeout');
                if (!this.waitingForCandidates) {
                    return;
                }
                this.onDoneWaitingForCandidates();
            },
        },
        {
            key: 'onDoneWaitingForCandidates',
            value: function onDoneWaitingForCandidates() {
                var _this = this;
                return _async_to_generator(function () {
                    return _ts_generator(this, function (_state) {
                        switch (_state.label) {
                            case 0:
                                _this.waitingForCandidates = false;
                                clearTimeout(_this.iceGatheringTimeout);
                                if (!(_this.whepType === 0)) return [3, 2];
                                return [4, _this.sendOffer()];
                            case 1:
                                _state.sent();
                                return [3, 4];
                            case 2:
                                return [4, _this.sendAnswer()];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [2];
                        }
                    });
                })();
            },
        },
        {
            key: 'getResouceUrlFromHeaders',
            value: function getResouceUrlFromHeaders(headers) {
                var _headers_get;
                if (
                    headers.get('Location') &&
                    ((_headers_get = headers.get('Location')) === null || _headers_get === void 0 ? void 0 : _headers_get.match(/^\//))
                ) {
                    var resourceUrl = new URL(headers.get('Location'), this.channelUrl.origin);
                    return resourceUrl.toString();
                } else {
                    return headers.get('Location');
                }
            },
        },
        {
            key: 'requestOffer',
            value: function requestOffer() {
                var _this = this;
                return _async_to_generator(function () {
                    var response, offer, serverMessage;
                    return _ts_generator(this, function (_state) {
                        switch (_state.label) {
                            case 0:
                                if (!(_this.whepType === 1)) return [3, 5];
                                _this.log('Requesting offer from: '.concat(_this.channelUrl));
                                return [
                                    4,
                                    fetch(_this.channelUrl.toString(), {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/sdp',
                                            Authorization: 'Basic ' + btoa(_this.credeintials),
                                        },
                                        body: '',
                                    }),
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) return [3, 3];
                                _this.resource = _this.getResouceUrlFromHeaders(response.headers);
                                _this.log('WHEP Resource ', _this.resource);
                                return [4, response.text()];
                            case 2:
                                offer = _state.sent();
                                _this.log('Received offer', offer);
                                return [2, offer];
                            case 3:
                                return [4, response.text()];
                            case 4:
                                serverMessage = _state.sent();
                                throw new Error(serverMessage);
                            case 5:
                                return [2];
                        }
                    });
                })();
            },
        },
        {
            key: 'sendAnswer',
            value: function sendAnswer() {
                var _this = this;
                return _async_to_generator(function () {
                    var answer, response;
                    return _ts_generator(this, function (_state) {
                        switch (_state.label) {
                            case 0:
                                if (!_this.localPeer) {
                                    _this.log('Local RTC peer not initialized');
                                    return [2];
                                }
                                if (!(_this.whepType === 1 && _this.resource)) return [3, 2];
                                answer = _this.localPeer.localDescription;
                                if (!answer) return [3, 2];
                                _this.log('DSADAWe');
                                return [
                                    4,
                                    fetch(_this.resource, {
                                        method: 'PATCH',
                                        headers: {
                                            'Content-Type': 'application/sdp',
                                            Authorization: 'Basic ' + btoa(_this.credeintials),
                                        },
                                        body: answer.sdp,
                                    }),
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) {
                                    _this.error('sendAnswer response: '.concat(response.status));
                                }
                                _state.label = 2;
                            case 2:
                                return [2];
                        }
                    });
                })();
            },
        },
        {
            key: 'sendOffer',
            value: function sendOffer() {
                var _this = this;
                return _async_to_generator(function () {
                    var offer, response, answer, err;
                    return _ts_generator(this, function (_state) {
                        switch (_state.label) {
                            case 0:
                                if (!_this.localPeer) {
                                    _this.log('Local RTC peer not initialized');
                                    return [2];
                                }
                                offer = _this.localPeer.localDescription;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([1, 7, , 8]);
                                if (!(_this.whepType === 0 && offer)) return [3, 6];
                                _this.log('Sending offer to '.concat(_this.channelUrl));
                                return [
                                    4,
                                    fetch(_this.channelUrl.toString(), {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/sdp',
                                            Authorization: 'Basic ' + btoa(_this.credeintials),
                                        },
                                        body: offer.sdp,
                                    }),
                                ];
                            case 2:
                                response = _state.sent();
                                if (!response.ok) return [3, 5];
                                _this.resource = _this.getResouceUrlFromHeaders(response.headers);
                                _this.log('WHEP Resource', _this.resource);
                                return [4, response.text()];
                            case 3:
                                answer = _state.sent();
                                return [
                                    4,
                                    _this.localPeer.setRemoteDescription({
                                        type: 'answer',
                                        sdp: answer,
                                    }),
                                ];
                            case 4:
                                _state.sent();
                                return [3, 6];
                            case 5:
                                if (response.status === 400) {
                                    _this.log('server does not support client-offer, need to reconnect');
                                    _this.whepType = 1;
                                    _this.onErrorHandler('reconnectneeded');
                                } else if (
                                    response.status === 406 &&
                                    _this.audio &&
                                    !_this.mediaConstraints.audioOnly &&
                                    !_this.mediaConstraints.videoOnly
                                ) {
                                    _this.log("maybe server does not support audio. Let's retry without audio");
                                    _this.audio = false;
                                    _this.video = true;
                                    _this.onErrorHandler('reconnectneeded');
                                } else if (
                                    response.status === 406 &&
                                    _this.video &&
                                    !_this.mediaConstraints.audioOnly &&
                                    !_this.mediaConstraints.videoOnly
                                ) {
                                    _this.log("maybe server does not support video. Let's retry without video");
                                    _this.audio = true;
                                    _this.video = false;
                                    _this.onErrorHandler('reconnectneeded');
                                } else {
                                    _this.error('sendAnswer response: '.concat(response.status));
                                    _this.onErrorHandler('connectionfailed');
                                }
                                _state.label = 6;
                            case 6:
                                return [3, 8];
                            case 7:
                                err = _state.sent();
                                _this.onErrorHandler((err === null || err === void 0 ? void 0 : err.message) || 'AIQUnknown');
                                return [3, 8];
                            case 8:
                                return [2];
                        }
                    });
                })();
            },
        },
        {
            key: 'log',
            value: function log() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }
                if (this.debug && isCameraStreamLogsEnabled()) {
                    var _console;
                    (_console = console).log.apply(_console, ['WebRTC-player'].concat(_to_consumable_array(args)));
                }
            },
        },
        {
            key: 'error',
            value: function error() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }
                if (isCameraStreamLogsEnabled('error')) {
                    var _console;
                    (_console = console).error.apply(_console, ['WebRTC-player'].concat(_to_consumable_array(args)));
                }
            },
        },
    ]);
    return AIQAdapter;
})();
